export default class Invoicing {
  constructor (companyName, distribution, distributionValue, email, marking, orgNumber, phone, postalAddress, postalCity, postalCode, reference, useCompanyAddress, gln, vatNumber) {
    this.companyName = companyName
    this.distribution = distribution
    this.distributionValue = distributionValue
    this.email = email
    this.marking = marking
    this.orgNumber = orgNumber
    this.phone = phone
    this.postalAddress = postalAddress
    this.postalCity = postalCity
    this.postalCode = postalCode
    this.reference = reference
    this.useCompanyAddress = useCompanyAddress
    this.gln = gln
    this.vatNumber = vatNumber
  }

  static asInvoicings (json) {
    return json.map(invoicing => {
      return Invoicing.asInvoicing(invoicing)
    })
  }

  static asInvoicing (json) {
    return new Invoicing(
      json.company_name,
      json.distribution,
      json.distribution_value,
      json.email,
      json.marking,
      json.org_number,
      json.phone,
      json.postal_address,
      json.postal_city,
      json.postal_code,
      json.reference,
      json.use_company_address,
      json.gln || '',
      json.vat_number
    )
  }

  get shouldShowEmailGlnWarning () {
    if (this.distributionValue === DISTRIBUTION_NUMBERS.DISTRIBUTION_PDF_EMAIL) {
      if (!this.email) {
        return true
      }
    }
    if (this.distributionValue === DISTRIBUTION_NUMBERS.DISTRIBUTION_EDI) {
      if (!this.gln) {
        return true
      }
    }
    return false
  }
}

export const DISTRIBUTION_NUMBERS = {
    DISTRIBUTION_PAPER: 1,
    DISTRIBUTION_PDF_EMAIL: 2,
    DISTRIBUTION_EDI: 3
  }
